import styled from "styled-components";
import theme from "../../../../theme";
import { Col, Row } from "antd";

export const PoweringSection = styled.div`
  background-color: ${(props) => props.color || theme.white};
  margin: 0 0 100px;
  padding: 100px 0;

  @media (max-width: 426px) {
    margin: 0 0 72px;
    padding: 72px 0;
  }
`;

export const EmailForm = styled.div`
  .gravityform__button {
    min-width: 300px;
    background-color: ${theme.cyan};
    padding: 10px 27px;
    border-radius: 1.875rem;
    color: ${theme.white};
    font-size: 16px;
    line-height: 21rem;
    min-width: 156px;
    display: inline-block;
    text-align: center;
  }

  .gravityform__button:hover {
    color: ${theme.black};
  }

  .hire_email_form form {
    display: flex;
    flex-direction: column;
    .gform_body {
      position: relative;
    }
    .validation_message {
      position: absolute;
      left: 0;
    }
  }
  .hire_email_form form .gravityform__button {
    margin-top: 0;
  }
  .hire_email_form form .gravityform__field__input {
    border: 1px solid #979797;
    border-radius: 30px;
    width: 80%;
    padding-left: 15px !important;
    padding: 10px;
    margin-right: 20px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .hire_email_form form .gravityform__field__input::placeholder {
    color: #979797;
    font-family: "Inter", sans-serif;
    opacity: 0.8;
  }

  @media only screen and (max-width: 768px) {
    margin-bottom: 75px;

    .hire_email_form form {
      display: block;
    }

    .hire_email_form form .gravityform__field__input {
      width: 60%;
    }
  }
  @media only screen and (max-width: 575px) {
    .hire_email_form form .gravityform__field__input {
      width: 100%;
    }
  }
`;

export const ScrollableRow = styled(Row)`
  position: relative;
`;

export const LeftSide = styled(Col)`
  height: fit-content;
  position: sticky;
  top: 30%;

  @media (max-width: 992px) {
    height: auto;
    position: relative;
    top: 0;
  }
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const StyledDiv = styled.div`
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
  padding-top: 40px;
  padding-bottom: 40px;
  list-style-type: none;

  @media (max-width: 426px) {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

export const StyledSubTitle = styled.ul`
  font-size: 40px;
  line-height: 48px;
  margin-bottom: 16px;
  color: ${theme.white};

  @media (max-width: 604px) {
    font-size: 25px;
    line-height: 38px;
  }
  @media (max-width: 419px) {
    font-size: 22px;
    line-height: 33px;
  }
  @media (max-width: 390px) {
    font-size: 24px;
    line-height: 31px;
  }
`;
export const StyledDiscription = styled.div`
  color: ${theme.white};
  li {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 8px !important;
    list-style-type: none !important;
    ::before {
      content: "-";
    }

    :last-child {
      margin-bottom: 0px !important;
    }

    @media (max-width: 604px) {
      font-size: 16px;
      line-height: 25px;
    }
    @media (max-width: 419px) {
      font-size: 13px;
      line-height: 20px;
    }
    @media (max-width: 390px) {
      font-size: 16px;
      line-height: 21px;
    }
  }
`;
